<template>
  <v-container pa-0>
    <v-layout>
      <v-flex xs6 pr-1>
        <v-text-field label="Name" v-model="Name" :rules="nameRule"></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs6 pr-3>
        <v-text-field label="Back tracking (Minutes)" :rules="numRuleNoZero" v-model="ExecuteInterval">
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">info_outline</v-icon>
              </template>
              Backtracking time refers the amount of time from the present the importer should look back when querying data.<br>
              For example, a backtracking time of 120 would cause the importer to query data from 2hrs ago to the present.
            </v-tooltip>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex xs6 pl-3>
        <v-text-field label="Type" v-model="ImporterType" disabled :rules="nullRule"></v-text-field>
      </v-flex>
    </v-layout>
    <v-text-field label="Description" v-model="Description"></v-text-field>
  </v-container>
</template>

<script>
  import ImporterConfigUtil from '@/components/mixins/ImporterConfigUtil'
  import { createNamespacedHelpers } from 'vuex'
  const continuousimporterconfig = createNamespacedHelpers('continuousimporterconfig')

  export default {
    mixins: [ImporterConfigUtil],
    props: {
      ImporterType: {
        type: String,
        default: '',
      },
      data: {
        type: Object,
        default: {},
      },
      Title: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        Name: '',
        ExecuteInterval: '',
        Description: '',
      }
    },
    computed: {
      ...continuousimporterconfig.mapGetters(['ImporterConfigs']),
    },
    watch: {
      data() {
        if (JSON.stringify(this.data) != '{}') {
          this.Name = this.data.Name
          this.ExecuteInterval = this.data.ExecuteInterval
          this.Description = this.data.Description
        }
      },
      Name() {
        this.emitData()
      },
      ExecuteInterval() {
        this.emitData()
      },
      Description() {
        this.emitData()
      },
    },
    methods: {
      emitData() {
        this.$emit('setGeneralData', {
          Name: this.Name,
          ExecuteInterval: this.ExecuteInterval,
          Description: this.Description,
        })
      },
    },
  }
</script>